<template>
  <div class="wuxing-compare" :class="{'is-modal': isModal}">
    <!-- 筛选标签 -->
    <div class="filter-bar">
      <div class="filter-tags">
        <span class="wx-tag wx-tag-info">保留辨证</span>
        <span class="label">本次看诊仍存在</span>
        <span class="wx-tag wx-tag-danger through-line">初诊消失</span>
        <span class="label">初诊有、本次已无</span>
        <span class="wx-tag wx-tag-info through-line">上次消失</span>
        <span class="label">上次有、本次已无</span>
      </div>
      <Button type="primary" :loading="downloading" @click="onDownload">
        <Icon type="ios-download-outline" class="btn-icon" />下载对比图
      </Button>
    </div>

    <!-- 对比卡片列表 -->
    <div ref="compareCardsRef" class="compare-cards">
      <div v-for="(card, cIndex) in compareCardsFilter" :key="cIndex" class="compare-card"
        :class="{ 'card-current': card.isCurrent }">
        <!-- 卡片头部 -->
        <div class="card-header">
          <span class="card-title">{{ card.label }}</span>
          <span class="card-date">{{ card.date }}</span>
        </div>

        <!-- 五行表格 -->
        <div class="wuxing-table">
          <div class="wuxing-row wuxing-header">
            <div v-for="col in wuxingCols" :key="col" class="wuxing-cell wuxing-col-header">
              {{ col }}
            </div>
          </div>
          <div class="wuxing-body">
            <div v-for="col in wuxingCols" :key="col" class="wuxing-col">
              <div v-for="(item, iIndex) in (card.items[col] || [])" :key="iIndex" class="syndrome-item"
                :class="getSyndromeClass(item, card)">
                {{ item.dialecticsName }}
              </div>
            </div>
          </div>
        </div>

        <!-- 卡片底部统计 -->
        <div class="card-footer">
          <span>共{{ card.total }}个</span>
          <span v-if="!card.isCurrent">消失{{ card.disappeared }}个</span>
          <span v-else>当前证型</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toPng } from "html-to-image";
import request from "@/utils/request";
import dayjs from "dayjs";

export default {
  name: "WuxingCompare",
  props: {
    activeItem: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Object,
      default: () => { }
    },
    isModal: {
      type: Boolean,
      default: false 
    }
  },
  watch: {
    data(newValue, oldValue) {
      this.getData();
    }
  },
  data() {
    return {
      show: false,
      downloading: false,
      wuxingCols: ["木", "火", "土", "金", "水"],
      patientAnalysisFiveLineDiffChanges: {},
      // 模拟数据，实际由外部传入
      compareCards: [
        {
          label: "初诊",
          value: "firstWx",
          date: "2026-07-15",
          isCurrent: false,
          total: 25,
          disappeared: 13,
          isHide: false,
          items: {},
        },
        {
          label: "上一次看诊",
          value: "lastWx",
          date: "2026-09-06",
          isCurrent: false,
          total: 16,
          disappeared: 8,
          isHide: false,
          items: {},
        },
        {
          label: "本次看诊",
          value: "currWx",
          date: "2026-09-15",
          isCurrent: true,
          total: 11,
          disappeared: 0,
          isHide: false,
          items: {},
        },
      ],
    };
  },
  computed: {
    compareCardsFilter() {
      return this.compareCards.filter((i) => !i.isHide);
    },
  },
  methods: {
    getSyndromeClass(item, card) {
      let obj = {};
      if (item.isDel) {
        obj["through-line"] = true;
        if (card.value == "lastWx") {
          obj["text-kept"] = true;
          obj["syndrome-lost"] = true;
        } else {
          obj["syndrome-kept"] = true;
        }
      } else {
        obj["syndrome-lost"] = true;
      }
      return obj;
    },
    onDownload() {
      const el = this.$refs.compareCardsRef;
      if (!el || this.downloading) return;
      this.downloading = true;
      // 备份并临时取消滚动裁剪，确保完整内容被截取
      const prevOverflow = el.style.overflow;
      const prevMaxHeight = el.style.maxHeight;
      const prevScrollTop = el.scrollTop;
      el.style.overflow = "visible";
      el.style.maxHeight = "none";
      el.scrollTop = 0;
      // 等待样式生效（两帧确保浏览器完成重排重绘）
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          toPng(el, {
            pixelRatio: 2,
            backgroundColor: "#ffffff",
            cacheBust: false,
          })
            .then((dataUrl) => {
              let name = `五行图辨证对比_${dayjs().format("YYYYMMDDHHmmss")}.png`;
              const link = document.createElement("a");
              link.download = name;
              link.href = dataUrl;
              link.click();
            })
            .catch(() => {
              this.$Message.error("下载对比图失败");
            })
            .finally(() => {
              el.style.overflow = prevOverflow;
              el.style.maxHeight = prevMaxHeight;
              el.scrollTop = prevScrollTop;
              this.downloading = false;
            });
        });
      });
    },
    getData() {
      if(!this.isModal) {
        this.formatData(this.data || {});
        return;
      };
      let obj = {
        id: this.activeItem.id,
        patientCode: this.activeItem.patientCode,
      };
      request.post("/saasbaihui/patientAnalysisFiveLineDiffChanges", obj).then((res) => {
        this.formatData(res.result);
      });
    },
    formatData(obj) {
      if (!obj.lastDisappearWx) {
        obj.lastDisappearWx = [];
      }
      if (!obj.firstDisappearWx) {
        obj.firstDisappearWx = [];
      }
      this.patientAnalysisFiveLineDiffChanges = obj;
      this.setCompareCards(obj);
    },
    setCompareCards(data) {
      ["firstDisappearWx", "lastDisappearWx"].forEach((key) => {
        data[key].forEach((i) => {
          i.isDel = true;
        });
      });
      this.compareCards.forEach((card) => {
        let items = {};
        let list = data[card.value] || [];
        card.total = list.length;
        switch (card.value) {
          case "firstWx":
            card.disappeared = data["firstDisappearWx"].length;
            list.push(...data["firstDisappearWx"]);
            card.date = data["firstDate"];
            break;
          case "lastWx":
            card.disappeared = data["lastDisappearWx"].length;
            list.push(...data["lastDisappearWx"]);
            card.date = data["lastDate"];
            break;
          case "currWx":
            card.date = data["currDate"];
            break;
        }
        let flog = false;
        this.wuxingCols.forEach((col) => {
          items[col] = list.filter((i) => i.name === col);
          if (items[col].length > 0) {
            flog = true;
          }
        });
        card.isHide = !flog;
        card.items = items;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.wuxing-compare {
  padding-bottom: 20px;
  &.is-modal {
    max-height: 75vh;
    overflow-y: auto;
  }

  .filter-tags {
    .wx-tag {
      margin-right: 0;
    }

    .label {
      margin-right: 15px;
    }
  }

  .through-line {
    text-decoration: line-through;

    &.text-kept {
      opacity: 0.7;
    }
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e4e7ed;

    .filter-tags {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
    }

    .btn-icon {
      margin-right: 4px;
    }
  }

  .compare-cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    padding-right: 4px;
  }

  /* 替换 el-tag（iView 无对应组件） */
  .wx-tag {
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 9px;
    font-size: 12px;
    line-height: 1;
    border-radius: 4px;
    border: 1px solid transparent;
    white-space: nowrap;
    box-sizing: border-box;

    &.wx-tag-info {
      background: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399;
    }

    &.wx-tag-danger {
      background: #fef0f0;
      border-color: #fde2e2;
      color: #f56c6c;
    }
  }

  .compare-card {
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    overflow: hidden;

    &.card-current {
      border-color: #e6a2a0;
    }

    .card-header {
      padding: 0 16px;
      line-height: 26px;
      background: #f2f3f5;
      border-bottom: 1px solid #e4e7ed;
      text-align: center;

      .card-title {
        font-size: 15px;
        font-weight: 600;
        padding-right: 15px;
      }

      .card-date {
        font-size: 13px;
        opacity: 0.9;
      }
    }

    &.card-current .card-header {
      background: #e6a2a0;

      .card-title,
      .card-date {
        color: #fff;
      }
    }

    .wuxing-table {
      .wuxing-row {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
      }

      .wuxing-header {
        .wuxing-col-header {
          text-align: center;
          font-weight: 600;
          font-size: 15px;
          padding: 2px 0;
          line-height: 24px;
          border: 1px solid #e4e7ed;
          border-width: 0 1px 1px 0;

          &:last-child {
            border-right: none;
          }
        }
      }

      .wuxing-body {
        display: grid;
        grid-template-columns: repeat(5, 1fr);

        .wuxing-col {
          border-right: 1px solid #e4e7ed;
          padding: 6px;
          min-height: 40px;

          &:last-child {
            border-right: none;
          }
        }
      }
    }

    .syndrome-item {
      padding: 6px 8px;
      margin-bottom: 4px;
      border-radius: 4px;
      font-size: 13px;
      text-align: center;
      line-height: 1.4;

      &:last-child {
        margin-bottom: 0;
      }

      &.syndrome-kept {
        background: #fde8e8;
        color: #d80e20;
      }

      &.syndrome-lost {
        background: #f2f3f5;

        &.syndrome-text-lost {
          color: #f56c6c;
        }
      }

      &.syndrome-current {
        background: #fde8e8;
        color: #303133;
      }
    }

    .card-footer {
      text-align: right;
      padding: 2px 16px;
      line-height: 20px;
      font-size: 13px;
      border-top: 1px solid #e4e7ed;
      background: #f2f3f5;

      span {
        margin-left: 16px;
      }
    }
  }
}
</style>
